"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _texts = require("../texts");
var _util = require("../../../util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  if (typeof document === "undefined") {
    return;
  }
  var styles = ".pf-texts {\n  margin: 0;\n}\n\n.pf-table {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  padding: 24px;\n  padding-bottom: 16px;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  width: 343px;\n  margin: 0 auto;\n  background: #F5F9FB;\n}\n@media (min-width: 768px) {\n  .pf-table {\n    display: grid;\n    margin: 16px auto;\n    grid-template-columns: 264px 304px;\n    width: 680px;\n    justify-content: normal;\n    background: #FFF;\n    padding: 0;\n  }\n}\n@media (min-width: 1280px) {\n  .pf-table {\n    grid-template-columns: 293px 304px;\n  }\n  .pf-table__header {\n    font-size: 18px;\n    line-height: 28px;\n  }\n  .pf-table__text {\n    font-size: 18px;\n    line-height: 28px;\n  }\n  .pf-table .pf-table__sub-text {\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n.pf-table__header {\n  font-weight: 400;\n  color: #557B92;\n}\n.pf-table__text {\n  font-weight: 700;\n  color: #113B5E;\n  padding-bottom: 16px;\n}\n@media (min-width: 768px) {\n  .pf-table__text {\n    padding-left: 24px;\n    background: #F5F9FB;\n  }\n}\n@media (min-width: 768px) {\n  .pf-table dt:first-of-type {\n    padding-top: 24px;\n  }\n}\n@media (min-width: 768px) {\n  .pf-table dd:first-of-type {\n    padding-top: 24px;\n  }\n  .pf-table dd:last-of-type {\n    padding-bottom: 24px;\n  }\n}\n.pf-table dd:last-of-type {\n  padding-bottom: 8px;\n}\n.pf-table .pf-table__sub-text {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}";
  var fileName = "table_styles_ddfd3e7a-7575-422d-bc47-a345b9af19c7";
  var element = document.querySelector("style[data-sass-component='table_styles_ddfd3e7a-7575-422d-bc47-a345b9af19c7']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var BLOCK_CLASS = 'pf-table';
var bem = (0, _util.klass)(BLOCK_CLASS);
var Table = function Table(_ref) {
  var rows = _ref.rows,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("dl", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS)
  }, rows.map(function (row) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: row.header
    }, /*#__PURE__*/_react.default.createElement(_texts.Text, {
      "data-test-id": row.id,
      as: "dt",
      className: bem('header')
    }, row.header), /*#__PURE__*/_react.default.createElement(_texts.Text, {
      as: "dd",
      className: bem('text', row.subText && 'text--has-sub-text')
    }, row.text, /*#__PURE__*/_react.default.createElement(_texts.Text, {
      className: bem('sub-text')
    }, row.subText)));
  }));
};
Table.propTypes = {
  rows: _propTypes.default.arrayOf(_propTypes.default.shape({
    header: _propTypes.default.string,
    text: _propTypes.default.string,
    subText: _propTypes.default.string
  })).isRequired,
  className: _propTypes.default.string
};
Table.defaultProps = {
  className: ''
};
var _default = exports.default = Table;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');